import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

const IconCheckCircle = (props) => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || {}, className);

  return (
    <svg
      className={classes}
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 11L10 13L15 8M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="#00BE35"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

IconCheckCircle.defaultProps = {
  rootClassName: null,
  className: null,
};

IconCheckCircle.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconCheckCircle;
